import React from 'react';
import { getSysFieldid } from '@platform/api';
import { Tooltip, ScrollElement } from '@platform/base';
import classnames from 'classnames';

// form变化,表格重新计算标识
const BEFOREFORMCOMPLETE = 'beforeAreaChangeComplete';
const FORMCOMPLETE = 'areaChangeComplete';

export default function FormWrapper(props) {
    const { store, showMainAreaName, headLeftArea, children, name, className, fastToNext, mainId, onOpenChange, showGroupTooltip = true } = props;
    const { getStore, getJson } = store.getInnerHooks();
    let langJson = getJson();
    let areaVisible = getStore([name, 'areaVisible']);
    areaVisible = areaVisible === undefined ? true : areaVisible;
    let isunfold = getStore([name, 'isunfold']);
    // 兼容页签主表 isunfold false情况
    if (((getStore(['tabsId']) || []).includes(name)) && !showMainAreaName) {
        isunfold = true;
    } else {
        isunfold = isunfold === undefined ? true : isunfold;
    }
    let groupFormClass = classnames({
        'show-form': isunfold,
        'hide-form': !isunfold,
    });
    let foldFontSize = getStore('foldFontSize');
    let foldFontWeight = getStore('foldFontWeight');
    const foldFontSizeStyle = foldFontSize ? { fontSize: foldFontSize + 'px' } : {};
    const foldFontWeightStyle = foldFontWeight ? { fontWeight: 800 } : {};
    // 区域展开收起
    function toggleArea(name, value) {
        const { openArea, closeArea } = store;
        PubSub.publishSync(BEFOREFORMCOMPLETE, true);
        if (value) {
            closeArea(name);
        } else {
            openArea(name);
        }
        setTimeout(() => {
            PubSub.publish(FORMCOMPLETE, true);
        }, 0);
        onOpenChange?.(name, !value);
    };

    if (areaVisible) {
        let isTabsForm = getStore(['isTabsForm']);
        let Wrapper = isTabsForm && mainId === name ? React.Fragment : ScrollElement;
        return (
            <Wrapper name={name} className={isunfold ? 'group-form-wrapper-open' : 'group-form-wrapper-close'}>
                <div
                    className="group-form-wrapper cf"
                    // 给快捷键用 如果要改 注意下
                    id={`form_${name}`}
                >
                    {!!headLeftArea && headLeftArea}
                    {(showMainAreaName || mainId !== name) && <div className="group-form-name">
                        <div
                            className="operator"
                            fieldid={getSysFieldid(`${mainId && name}_group`)}
                            tabIndex={0}
                            id={`toggleIcon2${name}`}
                            onClick={toggleArea.bind(
                                null,
                                name,
                                isunfold,
                            )}
                            onKeyDown={e => {
                                if (e.keyCode === 32) { // space
                                    e.preventDefault();
                                    e.target.click();
                                }
                                if (e.keyCode === 13) { // enter
                                    e.preventDefault();
                                    fastToNext(store, name, null, isunfold);
                                }
                            }}
                        >
                            {showGroupTooltip ? <Tooltip
                                placement="top"
                                overlay={isunfold ? langJson['form-group-close'] : langJson['form-group-expand']}
                                delayHide={1}
                                delayShow={1000}
                            >
                                <span
                                    className="name"
                                    style={{ ...foldFontSizeStyle, ...foldFontWeightStyle }}
                                >      
                                     <span className="name-icon">
                                        {isunfold ? '-' : '+'}
                                    </span>
                                    {getStore([name, 'name'])}
                                </span>
                            </Tooltip> :
                                <span
                                    className="name"
                                    style={{ ...foldFontSizeStyle, ...foldFontWeightStyle }}
                                >
                                    <span className="name-icon">
                                        {isunfold ? '-' : '+'}
                                    </span>
                                    {getStore([name, 'name'])}
                                </span>}
                            <span
                                className="line-wrap"
                            >
                                <span className="line" />
                            </span>
                        </div>
                    </div>
                    }
                    {isunfold && <div className={`group-form-item ${groupFormClass} ${className}`}>
                        {children}
                    </div>}
                </div>
            </Wrapper>
        )
    } else {
        return null;
    }
}